module.exports = __webpack_public_path__ + "media/partenaire/note-portrait-de86ecb0.png";